module.exports = __webpack_public_path__ + "img/crossover_driving.486923d0.svg";